import store from '../reducers'
import events from 'actions/events'
import dayjs from 'lib/helpers/dayjs';
import { PageActions, FilterActions } from 'actions'

export default () => {
    events.on('Organization.dataFetched',()=>{
        if(
            store.getState().session && store.getState().session.accountID &&
            store.getState().config && store.getState().config.date && store.getState().config.appointmentTypeID
        ){
            FilterActions.set({
                ...store.getState().filters,
                authenticator: store.getState().session.account.email,
                startDate: dayjs(store.getState().config.date).format(),
                date: dayjs(store.getState().config.date).format(),
                appointmentTypeID: store.getState().config.appointmentTypeID,
                patientCount: 1
            })
            PageActions.navToTimeSlots()
        }
    })

    events.on('Filters.componentDidSubmit',()=>{
        PageActions.navToCollectInformation()
    })
    
    events.on('TimeSlots.componentDidSubmit',()=>{
        PageActions.navToCollectInformation()
    })

    events.on('ContactInformation.componentDidSubmit',()=>{
        if(!store.getState().selectedTimeSlot.id){
            PageActions.navToTimeSlots()
        }
    })
    
    events.on('CollectInformation.componentDidSubmit',()=>{
        PageActions.navToConfirmation()
    })

    events.on('Confirmation.componentDidSubmit',()=>{
        PageActions.navToReceipt()
    })
}


// WEBPACK FOOTER //
// ./eventFlows/defaultWaitList.js